/* eslint-disable no-magic-numbers */

import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Tab, TabList, TabPanel, Tabs } from 'carbon-react/lib/components/tabs/__next__';

import { useConsolidationContext } from '../../consolidation-context/consolidation-context';
import { FxRatesCurrencyCalendar } from './fx-rates-currency-calendar/fx-rates-currency-calendar';
import * as styles from './daily-fx-rates.scss';
import { EditDailyFxRatesSidebar } from './edit-daily-fx-rates-modal/edit-daily-fx-rates-sidebar';

export const DailyFxRates = () => {
  const {
    dailyFxRates: { handleChangeFxRatesCurrencyTab, selectedFXCurrencyCode },
    settings: { uniqueFxCurrencyCodes }
  } = useConsolidationContext();

  const intl = useIntl();

  const tabs = useMemo(
    () =>
      uniqueFxCurrencyCodes.map(code => ({
        id: code,
        label: code,
        children: <FxRatesCurrencyCalendar />
      })),
    [uniqueFxCurrencyCodes]
  );

  const handleCarbonTabChange = useCallback(
    (tabId: string) => {
      const currentTabIndex = tabs.findIndex(t => t.id === tabId);
      handleChangeFxRatesCurrencyTab(currentTabIndex);
    },
    [handleChangeFxRatesCurrencyTab, tabs]
  );

  return (
    <div>
      <div className={styles.carbonTabsContainer}>
        <Tabs orientation="horizontal" selectedTabId={selectedFXCurrencyCode}>
          <TabList
            ariaLabel={intl.formatMessage({
              id: 'consolidation.daily_fx_rates.tabs.aria_label',
              defaultMessage: 'Daily FX rates'
            })}
            onTabChange={handleCarbonTabChange}
          >
            {tabs.map(t => (
              <Tab key={t.id} id={t.id} controls={`${t.id}-panel`} label={t.label} />
            ))}
          </TabList>
          {tabs.map(t => (
            <TabPanel key={t.id} id={`${t.id}-panel`} tabId={t.id}>
              {t.children}
            </TabPanel>
          ))}
        </Tabs>
      </div>
      <EditDailyFxRatesSidebar />
    </div>
  );
};
